import React, { memo } from 'react';
import MenuItemMobile from 'modules/shared/layout/menu/menu-mobile/components/menu-list-mobile/components/menu-item-mobile';
import MenuLinkMobile from 'modules/shared/layout/menu/menu-mobile/components/menu-list-mobile/components/menu-link-mobile';
import MenuInterface from 'modules/shared/layout/menu/interfaces/menu.interface';

import './menu-list-mobile.scss';

interface MenuListMobileProps {
    list: MenuInterface[];
    onClose: () => void;
    maxItems?: number;
    onShowAll?: () => void;
    isHidden?: boolean;
    loadMenu: boolean;
    level: number;
}

const MenuListMobile: React.FC<MenuListMobileProps> = ({
    list,
    onClose,
    maxItems,
    onShowAll,
    isHidden = false,
    loadMenu,
    level
}) => {
    return (
        <ul className="menu-list-mobile" data-section={`menu-level-${level}`}>
            {list.map((item, index) => (
                <MenuItemMobile
                    className={(isHidden && maxItems && maxItems <= index) ? 'menu-list-mobile__item--hidden' : undefined}
                    key={item.id}
                    item={item}
                    onClose={onClose}
                    loadMenu={loadMenu}
                    level={level}
                />
            ))}
            {onShowAll && isHidden && (
                <li className="menu-list-mobile__item">
                    <MenuLinkMobile
                        name="Pokaż wszystko"
                        onClick={onShowAll}
                    />
                </li>
            )}
        </ul>
    );
};

export default memo(MenuListMobile);
